import { put, takeLatest } from 'redux-saga/effects';
import { logger } from 'services';
import { updateRevenueRecognitionAction } from '../actions';
import { updateRecognitionConfigAction } from '../slices';
// DEAD CODE - Todo @Muskaan- remove this
function* updateMilestoneRevenueRecognitionAction(action) {
    try {
        const { payload: { milestoneRevenueRecognitionConfigs } } = action;
        yield put(updateRecognitionConfigAction({
            milestoneRevenueRecognitionConfigs
        }));
    } catch (error) {
        logger.error('an error on updating revenue recognition in template', {
            error
        });
    }
}
export function* watchMilestoneRecognisedRevenueActionSaga() {
    yield takeLatest(updateRevenueRecognitionAction.type, updateMilestoneRevenueRecognitionAction);
}
